import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPupBl } from './pages'

type TIdToPageMapWoofzPpp = Record<PageIdWoofzPupBl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PUP_BL: TIdToPageMapWoofzPpp = {
  [PageIdWoofzPupBl.DOG_AGE_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_bl/pages/questions/DogAge'),
  },
  [PageIdWoofzPupBl.DOG_OWNER_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/DogOwnerQuestion'
      ).then((m) => ({
        default: m.DogOwnerQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPupBl.TRAINING_COMMANDS_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/BasicTrainingCommands'
      ),
  },
  [PageIdWoofzPupBl.URGE_PAGE_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePage'),
  },
  [PageIdWoofzPupBl.DOG_BREED_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPupBl.FACING_CHALLENGES_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/FacingChallenges'
      ).then((m) => ({
        default: m.FacingChallenges,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPupBl.FACING_CHALLENGES_2_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPupBl.BEHAVIOR_FREQUENCY_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/BehaviorFrequency'
      ).then((m) => ({
        default: m.BehaviorFrequency,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPupBl.URGE_PROGRAM_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPupBl.BEHAVIOR_FEELINGS_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/questions/BehaviorFeelings'
      ).then((m) => ({
        default: m.BehaviorFeelings,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPupBl.FIX_BEHAVIOR_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/FixDogBehavior').then(
        (m) => ({
          default: m.FixDogBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPupBl.URGE_PAGE_4_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPupBl.COMMANDS_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/DogCommands'),
  },
  [PageIdWoofzPupBl.PARENT_GOAL_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPupBl.TRAINING_PLACE_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPupBl.TRAINING_FREQUENCY_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPupBl.URGE_PAGE_5_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPupBl.PREPARE_FLOW_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/prepare-flow/PrepareFlowPpp'
      ).then((m) => ({
        default: m.PrepareFlowPpp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPupBl.EMAIL_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_bl/pages/email/EmailPpp'),
  },
  [PageIdWoofzPupBl.NEWSLETTER_URGE_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPupBl.LAST_CHANCE_OFFER_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPupBl.SUBSCRIPTIONS_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPupBl.CHAT_UPSELL_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPupBl.UPSELL_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_bl/pages/upsell/Upsell'),
  },
  [PageIdWoofzPupBl.UPSELL_FEEDING_GUIDE_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPupBl.UPSELL_EMOTIONAL_SUPPORT_PUP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_bl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPupBl.DOWNLOAD_PUP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_bl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_bl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPupBl.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
